module.exports = {
  NgProbeToken: {},
  _createConditionalRootRenderer: function(rootRenderer, extraTokens, coreTokens) {
    return rootRenderer; 
  },
  __platform_browser_private__: {} 
};  
  


//////////////////
// WEBPACK FOOTER
// ./empty.js
// module id = 81
// module chunks = 0